import { render, staticRenderFns } from "./NewContactReportPage.vue?vue&type=template&id=0af70b14"
import script from "./NewContactReportPage.vue?vue&type=script&lang=js"
export * from "./NewContactReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports